module.exports = __webpack_public_path__ + "img/side-jumping-profile.9d16333f.svg";